module.exports = __webpack_public_path__ + "img/cHwRNUTw.d47a692d.svg";